import React from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { VARIANTS } from 'shared/constants';
import { getTicketSubjectPath } from 'shared/routes/support';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';
import { ticketColumns } from 'shared/components/table/ticketColumns';
import { GridWrapper } from 'shared/components/data-display/GridFormatter';

/**
 * @param {Object} props
 * @param {number} props.buildingId
 * @param {number} props.unitId
 * @param {Array<Object>} [props.tickets] - Tickets already fetched by the parent UnitView.
 */
export default function UnitTickets({
  buildingId,
  unitId,
  tickets,
}) {
  // UnitView already fetches these tickets; render its rows rather than re-fetching.
  const rows = tickets || [];

  return (
    <GridWrapper
      size={6}
      title="Tickets"
      titleIcon={(
        <Button
          sx={{ ml: 'auto' }}
          href={getTicketSubjectPath(buildingId, unitId)}
          variant={VARIANTS.outlined}
          target="_blank"
          startIcon={<Add />}
        >
          Create Ticket
        </Button>
      )}
    >
      <StickyHeadTable
        noRowsText="No tickets found"
        className="table-height-xs"
        columns={ticketColumns}
        rowId="id"
        rows={rows}
        striped
      />
    </GridWrapper>
  );
}
